import { BaseBrush } from './BaseBrush';
import { Grid } from '../Grid';
import { Particle } from '../Particle';

export type ParticleFactory = () => Particle;
export type OverwriteRule = (target: Particle | null) => boolean;

export interface ParticleBrushOptions {
    probability?: number;
    overwriteRule?: OverwriteRule;
}

export class ParticleBrush extends BaseBrush {
    name: string;
    private factory: ParticleFactory;
    private options: ParticleBrushOptions;

    constructor(name: string, factory: ParticleFactory, options: ParticleBrushOptions = {}) {
        super();
        this.name = name;
        this.factory = factory;
        this.options = {
            probability: 0.3, // 降低默认概率到 30%，让粒子生成更稀疏自然
            ...options
        };
    }

    protected applyAt(x: number, y: number, grid: Grid, dist: number, maxDist: number): void {
        const target = grid.get(x, y);
        
        // 检查覆盖规则
        let canOverwrite = false;
        if (this.options.overwriteRule) {
            canOverwrite = this.options.overwriteRule(target);
        } else {
            // 默认规则：只能覆盖空位置
            canOverwrite = !target || target.empty;
        }

        // 如果规则允许覆盖，再检查概率
        if (canOverwrite) {
            // 如果提供了概率且小于1，进行随机检查
            if (this.options.probability !== undefined && this.options.probability < 1) {
                // 计算基于距离的概率因子 (喷枪效果)
                // maxDist 可能为 0 (size=0)
                let densityFactor = 1.0;
                
                if (maxDist > 0) {
                    const normalizedDist = dist / maxDist; // 0 to 1
                    // 使用二次方或三次方衰减，让中心更密集，边缘更稀疏
                    const falloff = 1 - normalizedDist; 
                    densityFactor = falloff * falloff; // 二次衰减
                }
                
                // 结合基础概率和密度因子
                const finalProb = this.options.probability * densityFactor;

                if (Math.random() > finalProb) {
                    return;
                }
            }
            
            grid.set(x, y, this.factory());
        }
    }
}
